import type { SandboxPresetTag } from './sandbox/presetTags'

export type SandboxComponentPreset = {
  id: string
  title: string
  description: string
  tags: SandboxPresetTag[]
  category?: string
  html: string
  css: string
  js: string
}

/**
 * Shared shell for preset previews. Uses tokens from `PREVIEW_THEME_TOKENS_CSS` (injected before preset CSS)
 * so examples track the app light/dark toggle.
 *
 * Tokens: `--nogrok-preview-surface`, `--nogrok-preview-on-surface`, `--nogrok-preview-surface-container`,
 * `--nogrok-preview-surface-container-high`, `--nogrok-preview-surface-rail`, `--nogrok-preview-outline`,
 * `--nogrok-preview-primary`, `--nogrok-preview-on-primary`, `--nogrok-preview-accent-warm`, etc.
 */
export const SANDBOX_PRESET_BODY_CSS = `body {
  font-family: Manrope, system-ui, sans-serif;
  margin: 0;
  padding: 1rem;
  background: var(--nogrok-preview-surface);
  color: var(--nogrok-preview-on-surface);
  min-height: 100%;
  box-sizing: border-box;
}
* { box-sizing: border-box; }`
